<template>
  <div class="myArticel_content">
      <div class="ar_title">
        <div class="importTitlte">
          <span @click="changeTabs(1)" :class="newsTab == 1?'selectTabs':''" >资讯</span>
          <!-- <span  @click="changeTabs(2)"  :class="newsTab == 2?'selectTabs':''" >公告</span> -->
        </div>
        <span class="morenews" v-if="newsTab==1" style="cursor: pointer;" @click="moreNew">{{newsTab==1?'更多资讯':''}} <i class="el-icon-arrow-right"></i> </span>
      </div>
      <div v-if="newsTab == 1">
        <div class="ar_list" v-if="item.articleInfo" @mouseenter="mousearticle(item.articleInfo,index)" v-for="(item,index) in newsList" :key='index'>
          <div class="newContent" :class="mouseIndex == index?'noBottom':'ubottom'" v-if="item.articleInfo.articleId !== articleId">
            <div class="newtxt myfont">
               {{item.articleInfo.articleTitle}}
            </div>
            <div class="newTime">
              {{fiftime(item.articleInfo.createTime)}}
            </div>
          </div>

          <div class="newContent showbigdetails" @click="navDetails(item)" :class="articleId === item.articleInfo.articleId?'activeMouse':''" >
            <div class="art_img">
                <img :src="item.articleInfo.articleHeadImg" alt="" srcset="">
            </div>
            <div class="big_rightbox">
              <div class="title myfont1">
                {{item.articleInfo.articleTitle}}
              </div>
              <div class="samll_title myfont2">
               {{item.articleInfo.articleContent}}
              </div>
              <div class="art_status">
                <div class="art_items">
                  <img src="https://oss.ansongqiubo.com/static/news/liulan.png" alt="" srcset="">
                  <span>{{item.articleExtra.viewNum}}</span>
                </div>
                <div class="art_items">
                  <img src="https://oss.ansongqiubo.com/static/center/pinglun.png" alt="" srcset="">
                  <span>{{item.articleExtra.commentNum}}</span>
                </div>
                <div class="times">
                   {{fiftime(item.articleInfo.createTime)}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="ar_list"  @click="navDetails(item)" v-if="item.annTitle" v-for="(item,index) in publickList" :key='index'>
          <div class="newContent" v-if="item.announcementId !== articleId">
            <div class="newtxt myfont">
               {{item.annTitle}}
            </div>
            <div class="newTime">
              {{fiftime(item.publishTime)}}
            </div>
          </div>

          <div class="newContent showbigdetails" :class="articleId === item.announcementId?'activeMouse':''" >
           <div class="art_img">
                <img :src="item.articleInfo.articleHeadImg" alt="" srcset="">
            </div>
            <div class="big_rightbox">
              <div class="title myfont1">
                {{item.annTitle}}
              </div>
              <div class="samll_title myfont2">
               {{item.annContent}}
              </div>
             <div class="art_status">
                <div class="art_items">
                  <img src="https://oss.ansongqiubo.com/static/news/liulan.png" alt="" srcset="">
                  <span>{{item.articleExtra.viewNum}}</span>
                </div>
                <div class="art_items">
                  <img src="https://oss.ansongqiubo.com/static/center/pinglun.png" alt="" srcset="">
                  <span>{{item.articleExtra.commentNum}}</span>
                </div>
                <div class="times">
                   {{fiftime(item.articleInfo.createTime)}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

  </div>
</template>

<script>
  import {articleinfo,viewArticle ,announcementlist,announcementdetail} from '@/api/video.js'
  import moment  from 'moment'
  import $ from 'jquery'
  let Times = null
  export default {
    data() {
      return {
        key:'kay',
        newsList:[],
        publickList:[],
        mouseIndex:0,
        articleId:0,
        newsTab:1
      }
    },
    created() {
      articleinfo({
        deviceIdentify:'',
        firstReqTime:'',
        page:1,
        limit:7,
      }).then(res=>{
        if(res.data.code == 200 &&  res.data.data){
          console.log('咨询信息',res.data.data);

          this.newsList = res.data.data.list.map(item=>{
            item.articleInfo.articleContent = $( item.articleInfo.articleContent).text();
            return item
          });
          if(  this.newsList.length >0){
            this.articleId =  res.data.data.list[0].articleInfo.articleId
          }
        }
      })
    },
    methods:{
      changeTabs(v){
        this.newsTab = v;

        if(v == 2){
          announcementlist({}).then(res=>{
            if(res.data.code == 200){
              this.publickList = res.data.data
              console.log('公告列表',this.publickList);
            }
          })
        }


      },
      pageRouter(query){
        this.$store.commit('pageRouter',{
          type:1,
          query,
        })
      },
      moreNew(){
        this.pageRouter({
          path: "/informationlist",
          query: {
            rid: 3,
          },
        })
      },
      // 新闻页面
      navDetails(val){
        console.log(val);
        if(this.newsTab == 2){
            this.pageRouter({
              path: "/public",
              query: { aid: val.announcementId },
            })
          return
        }
        if(localStorage.getItem("token")){
          viewArticle({
            articleId:val.articleInfo.articleId,
          })
        }
        this.pageRouter({
          path: "/news",
          query: { aid: val.articleInfo.articleId },
        })
      },
      fiftime(val){
      	let t1= moment(val * 1000);
      	let t2 = moment();
      	let status = '';
      	if(t2.diff(t1, 'day') > 0){
          let days =  t2.diff(t1, 'day');
          if(days >= 4){
            return moment(val * 1000).format('YYYY-MM-DD')
          }else{
            status = days +'天前'
            return status
          }

      	}
      	if(t2.diff(t1, 'hour') > 0){
      		status = t2.diff(t1, 'hour') +'小时前'
      		return status
      	}

      	if(t2.diff(t1, 'minutes') > 0){
      		status = t2.diff(t1, 'minutes') +'分钟前'
      		return status
      	}
      	if(t2.diff(t1, 'seconds') >= 0){
      		status = '刚刚'
      		return status
      	}
      	console.log();//实际相差多少天 ， 第二个参数是单位
      	 // moment(val * 1000).format('YYYY-MM-DD HH:mm:ss')
      },
        // 鼠标移动
        mousearticle(e,i){
          this.mouseIndex = Math.abs( i - 1);


          console.log('数据',i);
          if(Times){
            clearTimeout(Times);
            Times =  setTimeout(()=>{
              console.log('执行1',Times);
              this.articleId = e.articleId;
            },260)
          }else{
           Times =  setTimeout(()=>{
             console.log('执行2',Times);
             this.articleId = e;
           },100)
          }

        }
    }
  }
</script>

<style lang="scss">
  .myfont1 {
  	overflow: hidden; //隐藏文字
  	text-overflow: ellipsis; //显示 ...
  	white-space: nowrap; //不换
  }
  .myfont2 {
  	 display: -webkit-box; /* 将对象作为弹性伸缩盒子模型显示 */
  	 -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
  	 -webkit-line-clamp: 2; /* 2行，只有 webkit内核支持 */
  	 word-break: break-all; /* 纯英文换行 */
  	 overflow: hidden;
  }
  .myArticel_content{
    .ar_list{
      padding: 2px 0;
    }
    .ar_list:last-child .newContent{
      border-bottom: 0 !important;
    }
    width: 392px;
    padding:0 12px;
    box-sizing: border-box;
    .activeMouse{
     height: 122px !important;
     transition: all .3s;
     padding: 12px;
    }
    .showbigdetails{
      height: 0px;
      padding: 0 !important;
      overflow: hidden;
      transition: all .2s;
      background: #F8F7F9;
      border-radius: 2px;
      box-sizing: border-box;
      margin:0 12px;
      border-bottom: 0 !important;
    }
    .noBottom{
      border-bottom: 1px solid rgba(0,0,0,0) !important;
      transition: all .5s;
    }

    .newContent{
      padding: 12px 0;
      margin: 0 12px;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      transition: all .5s;
      border-bottom: 1px solid rgba(0,0,0,.1);
      .big_rightbox{
        height: 98px;
        padding: 12px 12px 12px 6px;
        flex: 2;
        max-width:200px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .title{
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #721EDC;
        }
        .samll_title{
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
        .art_status{
          flex: 2;
          display: flex;
          align-items: flex-end;
          .times{
            flex: 2;
            display: flex;
            justify-content: flex-end;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
          }
          .art_items{
            margin-right: 12px;
            display: flex;
            align-items: center;
            img{
              width: 14px;
              height: 14px;
            }
            span{
              margin-left:4px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
            }
          }
        }
      }
      .art_img{
        width: 146px;
        height: 98px;
        margin-left: 14px;
        background: #D8D8D8;
        overflow: hidden;
        border-radius: 2px;
        position: relative;
        img{
           object-fit: cover;
         			background-size: cover;
         			background-repeat: no-repeat;
         			background-position: 50%;
         			position: absolute;
         			width: 100%;
         			height: 100%;
        }
      }
      .newTime{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
      .newtxt{
        width: 261px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
      }
    }
    .ar_title{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 60px;
      .selectTabs{
        border-bottom: 2px solid rebeccapurple;
        color: #333333  !important;
      }
      border-bottom: 1px solid rgba(0,0,0,.1);
      .importTitlte span{
        display: inline-block;
        margin-right: 12px;
        cursor: pointer;
        height: 100%;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #999;
        height: 60px;
        line-height: 60px;
      }
      .morenews{
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/template/newactice.vue